import {useTranslation} from "react-i18next";

const ButtonsDays = ({days, setDays, display}) => {
    const [_Tc] = useTranslation("datestimes");
    const handleClick = (e) => {
        let days_ = [...days];
        if (days_.includes(e.target.value)) {
            days_.splice(days.indexOf(e.target.value), 1);
        } else {
            days_.push(e.target.value);
        }
        setDays(days_);
    }

    return (
        display ?
            <div className="col-12">
                <button
                    type="button"
                    className={days.includes("1") ? "btn btn-circle btn-primary" : "btn btn-circle btn-light"}
                    value="1" onClick={handleClick}>{_Tc("days.1")}</button>
                <button
                    type="button"
                    className={days.includes("2") ? "btn btn-circle btn-primary" : "btn btn-circle btn-light"}
                    value="2" onClick={handleClick}>{_Tc("days.2")}</button>
                <button
                    type="button"
                    className={days.includes("3") ? "btn btn-circle btn-primary" : "btn btn-circle btn-light"}
                    value="3" onClick={handleClick}>{_Tc("days.3")}</button>
                <button
                    type="button"
                    className={days.includes("4") ? "btn btn-circle btn-primary" : "btn btn-circle btn-light"}
                    value="4" onClick={handleClick}>{_Tc("days.4")}</button>
                <button
                    type="button"
                    className={days.includes("5") ? "btn btn-circle btn-primary" : "btn btn-circle btn-light"}
                    value="5" onClick={handleClick}>{_Tc("days.5")}</button>
                <button
                    type="button"
                    className={days.includes("6") ? "btn btn-circle btn-primary" : "btn btn-circle btn-light"}
                    value="6" onClick={handleClick}>{_Tc("days.6")}</button>
                <button
                    type="button"
                    className={days.includes("0") ? "btn btn-circle btn-primary" : "btn btn-circle btn-light"}
                    value="0" onClick={handleClick}>{_Tc("days.0")}</button>
            </div>
            : <></>
    )
}

export default ButtonsDays;